if (!window.Promise) {
    window.Promise = require('promise-polyfill');
}

if (!Array.from) {
    Array.from = require('array-from');
}

if (!String.prototype.startsWith) {
    require('string.prototype.startswith');
}

require('es6-object-assign').polyfill();
require('object.values').shim();

require('picturefill')();
require('picturefill/dist/plugins/mutation/pf.mutation');
require('script-loader!custom-event-polyfill');
require('element-closest');
